export default "__VITE_ASSET__DzGYd5MD__"